import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function BookingSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");
  const bookingId = params.get("booking_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    let cancelled = false;

    const poll = async () => {
      if (cancelled || attempts >= 8) {
        if (!cancelled) setStatus("timeout");
        return;
      }
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
      } catch (err) {
        console.error("Payment status poll failed", err);
      }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-canvas">
      <Navbar />
      <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="booking-success-page">
        {status === "checking" && (
          <>
            <Loader2 className="h-10 w-10 text-moss animate-spin mx-auto mb-6" />
            <h1 className="font-serif text-4xl">Confirming your journey…</h1>
            <p className="text-muted2 mt-3">Just a moment while we verify your payment.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-moss mx-auto mb-6" />
            <h1 className="font-serif text-5xl">You're going.</h1>
            <p className="text-muted2 mt-4 leading-relaxed">Your booking is confirmed. Your host will be in touch shortly with the finer details of your journey.</p>
            <Link data-testid="view-my-bookings" to="/traveler" className="inline-block mt-8 rounded-full bg-moss text-canvas px-7 py-3">
              View my journeys
            </Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <XCircle className="h-12 w-12 text-terracotta mx-auto mb-6" />
            <h1 className="font-serif text-4xl">Something interrupted the checkout.</h1>
            <p className="text-muted2 mt-3">No charge was made. Please try again.</p>
            <Link to="/discover" className="inline-block mt-8 rounded-full bg-moss text-canvas px-7 py-3">Back to discover</Link>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
